import {
  ProjectAdminResponse,
  ProjectBaseRequest,
} from '@app/models/admin.model';

export function pickBaseRequest(
  project: ProjectAdminResponse
): ProjectBaseRequest {
  return {
    contactUserId: project.contactUserId ?? null,
    foundingMode: project.foundingMode,
    loanTerm: project.loanTerm ?? 0,
    classificationId: project.classification?.id,
    description: project.description ?? null,
    interestMin: project.interestMin ?? null,
    interestMax: project.interestMax ?? null,
    yieldMin: project.yieldMin ?? null,
    yieldMax: project.yieldMax ?? null,
    startCollectionDate: project.startCollectionDate ?? null,
    endCollectionDate: project.endCollectionDate ?? null,
    loanTypePaymentStart: project.loanTypePaymentStart ?? null,
    loanTypePaymentEnd: project.loanTypePaymentEnd ?? null,
    name: project.name ?? null,
    country: project.country ?? null,
    city: project.city ?? null,
    currency: project.currency ?? null,
  };
}
